export default __webpack_public_path__ + "static/media/link.2ec8be11.svg";